package com.karawek.core.auth.stytch.client

import kotlin.time.Instant

data class InitiateOtpResponse(
    val methodId: String,
    val requestId: String,
    val statusCode: Int,
)

data class AuthenticationResponse(
    val userId: String,
    val sessionToken: String,
    val sessionJwt: String,
    val sessionId: String,
    val startedAt: Instant,
    val expiresAt: Instant,
    val firstName: String? = null,
    val middleName: String? = null,
    val lastName: String? = null,
    val emailAddresses: List<String> = emptyList(),
    val phoneNumbers: List<String> = emptyList(),
    val profilePictureUrl: String? = null,
)
